import Button from '@mui/material/Button';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import * as yup from "yup";
import commonFunction from '../../Utils/commonFunction';
import Cookies from 'js-cookie';
import { userLogout } from '../../app/login/login.slice';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { config } from '../../Utils/axiosconfig';
import FormErrorMessage from '../Common/FormErrorMessage';
import { useEffect } from 'react';

function ChangePassword({ isPasswordModalOpen, closePasswordModal }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const schema = yup.object().shape({
        oldPassword: yup.string().required("Old Password is Required!"),
        newPassword: yup.string().required("Ny Adgangskode Er Nødvendig").min(8, 'Adgangskode for Kort  - Skal være på mindst 8 tegn'),
    });

    const [showPassword, setShowPassword] = useState(false);
    const [formError, setFormError] = useState('');

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: ''
        },
        validationSchema: schema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setFormError('');

            try {
                const response = await commonFunction.changePassword(values);
                if (response.status === 200 && response?.data?.status === true) {
                    toast.success("Adgangskoden blev ændret Log venligst ind igen.");
                    closePasswordModal();
                    formik.resetForm();
                    Cookies.remove('token');
                    await dispatch(userLogout(config));
                    await navigate('/login');
                } else {
                    setFormError(response?.data?.message || 'Unable to change password. Please try again.');
                }
            } catch (error) {
                setFormError('Der opstod en fejl under indsendelsen af formularen.');
            }
        },
    });

    const clearFormError = () => {
        setFormError('');
    };
    useEffect(() => {
        if (!formError) return;

        const timer = setTimeout(() => {
            setFormError('');
        }, 5000);

        return () => clearTimeout(timer);
    }, [formError]);

    return (
        <Dialog open={isPasswordModalOpen} onClose={closePasswordModal}>
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>Ændre Din Adgangskode</DialogTitle>
                <DialogContent>
                    Venligst Indtast din Gamle Og Nye Adgangskode.
                    <br />
                    <br />
                    <div className="form-group">
                        <label htmlFor="oldPassword">Gammel Adgangskode</label>
                        <input
                            type="text"
                            className={`form-control ${formik.touched.oldPassword && formik.errors.oldPassword ? 'input-error' : ''}`}
                            id="oldPassword"
                            placeholder="Indtast Gammel Adgangskode"
                            value={formik.values.oldPassword}
                            onChange={(e) => { formik.handleChange(e); clearFormError(); }}
                            onBlur={formik.handleBlur}
                            autoComplete="on"
                        />
                        {formError && <FormErrorMessage message={formError} />}
                    </div>

                    <div className="form-group">
                        <label htmlFor="newPassword">Ny Adgangskode</label>
                        <div className="d-flex align-items-center ">
                            <input type={showPassword ? 'text' : 'password'}
                                className="form-control" id="newPassword"
                                aria-describedby="emailHelp"
                                placeholder="Indtast Ny Adgangskode"
                                value={formik.values.newPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                autoComplete="on"
                            />
                            <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true" onClick={togglePasswordVisibility} style={{ marginLeft: '10px' }}></i>
                        </div>
                        {formik.touched.newPassword && formik.errors.newPassword && (
                            <FormErrorMessage message={formik.errors.newPassword} />
                        )}
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={closePasswordModal} color="primary">
                        Annullere
                    </Button>
                    <Button type="submit" color="primary">
                        Bekræft
                    </Button>
                </DialogActions>
            </form>
        </Dialog>

    )
}

export default ChangePassword